<template>
    <ButtonCircle :disabled="!isTrimExists || disabled" @click="centerTrimOnCanvas" title="Center the trim">
        <i class="icon-resize-normal"></i>
    </ButtonCircle>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import ButtonCircle from "../../components/ButtonCircle";

    export default {
        name: "CenterTrimOnCanvas",

        components: {
            ButtonCircle
        },

        props: [
            'disabled',
        ],

        computed: {
            ...mapGetters('editor', [
                'isTrimExists',
            ]),

        },

        methods: {
            ...mapActions('editor', [
                'centerTrimOnCanvas',
            ]),

        },

    }
</script>

<style scoped>
    button {
        margin: 0 5px;
    }
</style>